// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-button {
    background: #EA6C22;
    padding: 15px;
    border: none;
    border-radius: 15px;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    margin-top: 20px;
    transition: all 0.2s ease;
    display: inline-flex;
    justify-content: center;   /* افقی وسط */
    align-items: center;       /* عمودی وسط */
    gap: 0.5em;
}

/* ✅ حالت تمام عرض */
.primary-button.full-width {
    width: 100%;
}

/* ✅ حالت دکمه معمولی */
.primary-button:not(.full-width) {
    width: auto;
    min-width: 120px;  /* دلخواه؛ می‌تونی کم یا زیادش کنی */
}

.primary-button:hover {
    transform: rotateY(10deg);
}

/* حالت غیرفعال */
.primary-button:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

/* حالت لودینگ */
.primary-button.is-loading {
    pointer-events: none;
}

/* اسپینر */
.primary-button .spinner {
    width: 1.2em;
    height: 1.2em;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-top-color: black;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    display: inline-block;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.primary-button .btn-icon {
    display: flex;
    align-items: center;
    font-size: 1.2em;
}

.primary-button .btn-title {
    display: inline-block;
}



/* -----------------------------------------
   🔹 استایل کمکی برای حالت Outline
   ----------------------------------------- */
.primary-button.outline {
    background: transparent;         /* پس‌زمینه شفاف */
    border: 2px solid #EA6C22;       /* خط دور نارنجی */
    color: #EA6C22;                  /* رنگ متن */
}

/* هاور: پر شدن پس‌زمینه */
.primary-button.outline:hover:not(:disabled) {
    background: #EA6C22;
    color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/primaryButton/PrimaryButton.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB,IAAI,aAAa;IACxC,mBAAmB,QAAQ,cAAc;IACzC,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,gBAAgB,GAAG,oCAAoC;AAC3D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;AACxB;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;;;AAIA;;8CAE8C;AAC9C;IACI,uBAAuB,UAAU,kBAAkB;IACnD,yBAAyB,QAAQ,kBAAkB;IACnD,cAAc,mBAAmB,YAAY;AACjD;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".primary-button {\n    background: #EA6C22;\n    padding: 15px;\n    border: none;\n    border-radius: 15px;\n    color: #fff;\n    font-size: 15px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    justify-content: center;   /* افقی وسط */\n    align-items: center;       /* عمودی وسط */\n    gap: 0.5em;\n}\n\n/* ✅ حالت تمام عرض */\n.primary-button.full-width {\n    width: 100%;\n}\n\n/* ✅ حالت دکمه معمولی */\n.primary-button:not(.full-width) {\n    width: auto;\n    min-width: 120px;  /* دلخواه؛ می‌تونی کم یا زیادش کنی */\n}\n\n.primary-button:hover {\n    transform: rotateY(10deg);\n}\n\n/* حالت غیرفعال */\n.primary-button:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n/* حالت لودینگ */\n.primary-button.is-loading {\n    pointer-events: none;\n}\n\n/* اسپینر */\n.primary-button .spinner {\n    width: 1.2em;\n    height: 1.2em;\n    border: 2px solid rgba(0, 0, 0, 0.2);\n    border-top-color: black;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    display: inline-block;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.primary-button .btn-icon {\n    display: flex;\n    align-items: center;\n    font-size: 1.2em;\n}\n\n.primary-button .btn-title {\n    display: inline-block;\n}\n\n\n\n/* -----------------------------------------\n   🔹 استایل کمکی برای حالت Outline\n   ----------------------------------------- */\n.primary-button.outline {\n    background: transparent;         /* پس‌زمینه شفاف */\n    border: 2px solid #EA6C22;       /* خط دور نارنجی */\n    color: #EA6C22;                  /* رنگ متن */\n}\n\n/* هاور: پر شدن پس‌زمینه */\n.primary-button.outline:hover:not(:disabled) {\n    background: #EA6C22;\n    color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
